import _ from 'lodash';

export default function orderContactBlocks(savedOrder, registry) {
  const canonical = _.keys(registry);
  const order = _.isArray(savedOrder) ? savedOrder : [];
  const known = _.filter(order, key => _.has(registry, key));
  const missing = _.filter(canonical, key => !_.includes(known, key));
  return [...known, ...missing].map(key => ({key, node: registry[key]}));
}
